// extracted by mini-css-extract-plugin
export default {"services":"Services_services__NHXr5","container":"Services_container__1aoeh","servicesHeader":"Services_servicesHeader__Iojlu","servicesTitle":"Services_servicesTitle__gcEJA"};